// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4d6234f","977":"5e165a57"}[chunkId] + ".chunk.js";
};